import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-11b3a588"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-column flex-lg-row h-100" }
const _hoisted_2 = {
  key: 0,
  id: "selection-buttons",
  class: "row gx-0 justify-content-center align-content-start ps-4 pe-0 pb-4 bg-bloque-2"
}
const _hoisted_3 = { class: "selection-buttons-title col-12 text-center p-3 pt-4 pb-0 d-flex flex-column align-items-lg-start" }
const _hoisted_4 = {
  key: 0,
  style: {"max-width":"1100px","margin":"auto"}
}

import { VuexStore } from '@/interfaces/VuexStore'
import { key } from '@/setup/store'
import { onMounted, nextTick, ref } from 'vue'
import { useStore } from 'vuex'


export default /*#__PURE__*/_defineComponent({
  __name: 'ThePageContainer',
  setup(__props) {

const height = ref<number>(0)
const { state } = useStore<VuexStore>(key)

onMounted(() => {
  nextTick(() => {
    height.value =
      document.getElementsByClassName('selection-buttons-title')[0]
        ?.clientHeight ?? 0
  })
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(state).evento?.fidelizacion)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _renderSlot(_ctx.$slots, "title")
          ]),
          _createElementVNode("div", {
            class: "col-12 overflow-auto selection-buttons-button-container g-0",
            style: _normalizeStyle({ '--height': height.value + 'px' })
          }, [
            _renderSlot(_ctx.$slots, "selector")
          ], 4)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      id: "detail",
      class: _normalizeClass(["bg-bloque-3", _unref(state).evento?.fidelizacion ? 'fidelizacion' : ''])
    }, [
      (_unref(state).evento?.fidelizacion)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _renderSlot(_ctx.$slots, "content")
          ]))
        : _renderSlot(_ctx.$slots, "content", { key: 1 })
    ], 2)
  ]))
}
}

})